import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Col, Row, Switch, Typography, Button, message, Grid } from "antd";
import { useMobxStores } from "../../stores/stores";
import { observer } from "mobx-react";
import ActivityContainer from "./ActivityContainer";
import ItemDetailsMedia from "./ItemDetailsMedia";
import ItemDetailsMediaPhone from "./ItemDetailsMediaPhone";
import "./ItemDetailsPage.css";
import ItemDetailsInfo from "./ItemDetailsInfo";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ListForSaleModal from "./modals/ListForSaleModal";
import PurchaseOptionsModal from "./modals/PurchaseOptionsModal";
import PurchaseOptionsModalPhone from "./modals/PurchaseOptionsModalPhone";
import OptionsVertical from "../../assets/options-vertical.png";
import ItemDetailsBackground from "../../assets/item-details-background.png";
import ItemDetailsBackgroundPhone from "../../assets/phone_background_item.png";
import Loader from "../loaders/Loader";
import ItemDetailsPageDescription from "./ItemDetailsPageDescription";
import MainLoaderModal from "../loaders/MainLoaderModal";
import { ReactComponent as TopRightShape } from "../../assets/ItemDetailsRight.svg";

const { useBreakpoint } = Grid;

const ItemDetailsPage = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm; // < md = mobile
  const { marketplaceStore, userStore } = useMobxStores();
  const allowListing = marketplaceStore.listings?.some(
    (listing) => listing.seller_username === userStore.user?.username
  );

  const [modalVisible, setModalVisible] = useState(null);
  const [pendingApproval, setPendingApproval] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  const marketplaceItem = marketplaceStore.marketplaceItem?.item;
  const nft = marketplaceStore.NFT;

  useEffect(() => {
    marketplaceStore.GetMarketplaceItemById(params.pk);
    return () => {
      marketplaceStore.StopMarketplaceItemHistoryPolling();
    };
  }, [params.pk, marketplaceStore]);

  useEffect(() => {
    const fetchListings = async () => {
      if (marketplaceItem?.nft) {
        await marketplaceStore.GetListingsById(marketplaceItem.nft);
        await marketplaceStore.GetOwnershipById(marketplaceItem.nft);
      }
    };
    fetchListings();
  }, [marketplaceItem, marketplaceStore]);

  const handleSellingClick = async () => {
    if (!allowListing) {
      if (!localStorage.getItem("metaMask")) {
        message.error("Please connect to Metamask first");
        return;
      }
      try {
        setPendingApproval(true);
        const approved = await userStore.GetApprovalCheck({
          account: localStorage.getItem("metaMask"),
          chainid: nft.chainid,
        });

        if (!approved) {
          return;
        }
        if (approved) {
          setModalVisible("listForSale");
        }
      } catch (error) {
        setPendingApproval(false);
        console.error(error);
        return;
      } finally {
        setPendingApproval(false);
      }
    } else if (allowListing) {
      const listingObj = marketplaceStore.listings?.find(
        (item) => item.seller_username === userStore.user?.username
      );
      await marketplaceStore.UpdateNFT(nft?.id, {
        listed: false,
      });
      marketplaceStore.setNFTIsSelling(false);
      if (listingObj) {
        await marketplaceStore.DeleteListing(listingObj.id);
      }
    }
  };

  return (
    <div className="full-height">
      {isMobile ? (
        <>
          {" "}
          {marketplaceStore.fetchingMarketplaceItem ? (
            <Loader />
          ) : (
            <>
              <div className="details-container">
                <Row className="details-row">
                  <Col span={24}>
                    <Row className="flex-row">
                      <Col span={24}>
                        <Row>
                          <Col span={16}>
                            {/* {marketplaceItem?.tags?.map((tag, index) => (
        
                              {tag && ( <Typography
                                key={`${tag}-${index}`}
                                className="tag-text"
                              >
                                #{tag}
                              </Typography>)

                              }
                             
                            ))} */}

                            <Col span={19}>
                              <Row>
                                {marketplaceItem?.tags?.map((tag, index) =>
                                  tag ? (
                                    <span>
                                      <Typography
                                        key={`${tag}-${index}`}
                                        className="tag-text"
                                      >
                                        #{tag}
                                      </Typography>
                                    </span>
                                  ) : null
                                )}
                              </Row>
                            </Col>
                          </Col>
                          <Col span={8}>
                            {marketplaceItem?.nft &&
                              marketplaceStore.ownership.some(
                                (item) =>
                                  item.owner_username ===
                                  userStore.user?.username
                              ) && (
                                <Row
                                  align="middle"
                                  className="flex-row"
                                  style={{ justifyContent: "start" }}
                                >
                                  <Typography className="selling-text">
                                    Selling
                                  </Typography>
                                  <span>
                                    <Switch
                                      size="small"
                                      value={allowListing}
                                      onChange={handleSellingClick}
                                    />
                                  </span>
                                  <span>
                                    {allowListing && (
                                      <button
                                        className="tooltip-button"
                                        onClick={() =>
                                          setModalVisible("listForSale")
                                        }
                                      >
                                        <img
                                          src={OptionsVertical}
                                          alt="sale options"
                                        />
                                      </button>
                                    )}
                                  </span>
                                </Row>
                              )}
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Typography className="item-name">
                          {marketplaceItem?.name}
                        </Typography>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              {/* <Row className={"row-gap"}> */}
              {/* <Col span={24}> */}
              <div
                className="details-container"
                // className="details-bg-wrap"
              >
                <img
                  src={ItemDetailsBackgroundPhone}
                  alt="background"
                  style={{
                    zIndex: "-2",
                    height: "180vw",
                    width: "100vw",
                    marginTop: "-30vw",
                  }}
                  // className="details-bg-img"
                  className="details-background-phone"
                />
                <ItemDetailsMediaPhone />
              </div>
              {/* </Col> */}
              {/* </Row> */}
              <div className="details-container">
                <Row className={"row-gap"}>
                  <Col span={24} className="gradient-border">
                    {" "}
                    <ItemDetailsPageDescription
                      marketplaceItem={marketplaceItem}
                      nft={nft}
                    />
                    <ItemDetailsInfo setModalVisible={setModalVisible} />
                  </Col>
                </Row>
                <ActivityContainer />
                {modalVisible === "listForSale" && (
                  <ListForSaleModal
                    ownershipObj={marketplaceStore.ownership?.find(
                      (item) => item.owner_username === userStore.user?.username
                    )}
                    listingObj={marketplaceStore.listings?.find(
                      (item) => item.seller_username === userStore.user?.username
                    )}
                    isOpen={modalVisible === "listForSale"}
                    handleClose={() => setModalVisible(null)}
                  />
                )}
                {modalVisible === "purchaseOptions" && (
                  <PurchaseOptionsModalPhone
                    isOpen={modalVisible === "purchaseOptions"}
                    handleClose={() => setModalVisible(null)}
                  />
                )}
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {" "}
          {marketplaceStore.fetchingMarketplaceItem ? (
            <Loader />
          ) : (
            <div className="details-container">
              <img
                src={ItemDetailsBackground}
                alt="background"
                className="details-background"
              />
              <div
                style={{
                  // backgroundColor: " #000080",
                  position: "absolute",
                  inset: 0, // = top:0, right:0, bottom:0, left:0
                  zIndex: -1, // lower z-index
                }}
              >
                {/* <TopRightShape
              style={{
                // position: "",
                top: "32px",
                right: "0vw",
                width: "80vw", // scales with viewport width
                height: "auto", // keep aspect ratio
                pointerEvents: "none", // so it doesn’t block clicks
              }}
            /> */}
              </div>
              <Row className="details-row">
                <Button
                  icon={<ArrowLeftOutlined />}
                  className="simple-button"
                  size="large"
                  onClick={() => navigate(-1)}
                />
                <Col span={11}>
                  <Row className="flex-row">
                    <Col span={15}>
                      <Row>
                        {marketplaceItem?.tags?.map((tag, index) => (
                          <Typography
                            key={`${tag}-${index}`}
                            className="tag-text"
                          >
                            #{tag}
                          </Typography>
                        ))}
                      </Row>
                    </Col>
                    <Col span={9}>
                      {marketplaceItem?.nft &&
                        marketplaceStore.ownership.some(
                          (item) =>
                            item.owner_username === userStore.user?.username
                        ) && (
                          <Row
                            align="middle"
                            className="flex-row"
                            style={{ justifyContent: "start" }}
                          >
                            <Typography className="selling-text">
                              Selling
                            </Typography>
                            <span>
                              {" "}
                              <Switch
                                value={allowListing}
                                onChange={handleSellingClick}
                              />
                            </span>
                            <span>
                              {" "}
                              {allowListing && (
                                <button
                                  className="tooltip-button"
                                  onClick={() => setModalVisible("listForSale")}
                                >
                                  <img
                                    src={OptionsVertical}
                                    alt="sale options"
                                  />
                                </button>
                              )}
                            </span>
                          </Row>
                        )}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="row-gap">
                <Col span={10}>
                  <Typography className="item-name">
                    {marketplaceItem?.name}
                  </Typography>
                  <Col className="gradient-border">
                    <ItemDetailsPageDescription
                      marketplaceItem={marketplaceItem}
                      nft={nft}
                    />
                    <ItemDetailsInfo setModalVisible={setModalVisible} />
                  </Col>
                </Col>
                <Col span={2}></Col>
                <Col span={10}>
                  <ItemDetailsMedia />
                </Col>
              </Row>
              <ActivityContainer />
              {modalVisible === "listForSale" && (
                <ListForSaleModal
                  ownershipObj={marketplaceStore.ownership?.find(
                    (item) => item.owner_username === userStore.user?.username
                  )}
                  listingObj={marketplaceStore.listings?.find(
                    (item) => item.seller_username === userStore.user?.username
                  )}
                  isOpen={modalVisible === "listForSale"}
                  handleClose={() => setModalVisible(null)}
                />
              )}
              {modalVisible === "purchaseOptions" && (
                <PurchaseOptionsModal
                  isOpen={modalVisible === "purchaseOptions"}
                  handleClose={() => setModalVisible(null)}
                />
              )}
            </div>
          )}
        </>
      )}

      {pendingApproval && <MainLoaderModal />}
    </div>
  );
};

export default observer(ItemDetailsPage);
